import {useMutation} from "@tanstack/react-query";

import {addMaterialNoteMutationOptions} from "./add-material-note.mutation-options";

export function useAddMaterialNote(id: string) {
  return useMutation(addMaterialNoteMutationOptions(id));
}
